module.exports = __webpack_public_path__ + "static/media/result.ca5efffd.svg";